import { STORE_PAYMENT_OPTIONS } from "../actions";

export default function paymentOptions(state = null, action) {
    switch(action.type) {
        case STORE_PAYMENT_OPTIONS:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/paymentOptions.js